module.exports = __webpack_public_path__ + "static/media/alexandru_chelaru.9ce35748.png";